module.exports = __webpack_public_path__ + "static/1bots-c55e4430231f66db0b79f05e8627a4ad.png";